module.exports = __webpack_public_path__ + "img/0.f575ea6e.png";